<template>
	<vs-prompt
		:active.sync="activePrompt"
		:buttons-hidden="true"
		:title="$t('removalOrderReason')"
		button-accept="false"
		button-cancel="filled"
		:cancel-text="$t('doCancel')"
		color="primary"
	>
		<div class="con-exemple-prompt">
			{{ $t('doYouWantToRejectOrder') }}
			<ul class="leftx set-ticket-failed__list">
				<li
					v-for="(item, index) in reasonsList"
					:key="index"
				>
					<vs-radio
						v-model="reason"
						:vs-value="item.id"
						class="set-ticket-failed__item"
					>{{ item.name }}</vs-radio>
				</li>
			</ul>
			<div class="flex justify-end mt-8">
				<vs-button
					@click="accept"
					class="mr-4"
					:disabled="!reason"
					color="primary"
				>{{ $t('confirm') }}</vs-button>
				<vs-button
					@click="close()"
					color="dark"
 					type="border"
				>{{ $t('doCancel') }}</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "AddOrderToBasketPrompt",
	data() {
		return {
			reasonsList: [],
			reason: null,
		}
	},
	props: {
		active: {
			required: true,
			type: Boolean
		}
	},
	computed: {
		activePrompt: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		}
	},
	methods: {
		accept() {
			this.activePrompt = false;
			this.$emit("accept", this.reason);
		},
		close(){
			this.activePrompt = false;
		}
	},
	async created() {
		this.reasonsList = (await this.$http.get("/settings/get-order-delete-reasons")).data.data;
	}
}
</script>

<style scoped>
.vs-button-dark.vs-button-border, .vs-button-dark.vs-button-flat{
	border-left: 1px solid rgba(var(--vs-dark),1);
}
</style>
